// TODO: this page needs refactor

import React, { Children, useCallback, useMemo, useState } from 'react';
import { serialize, toKebabCaseWithAccentsCyrillicCJK } from 'corporate-utils';

import ModalWrapper from '../../modal/modal-wrapper/ModalWrapper';
import { ModalSize, ModalStyleType } from '../../../models/enum';
import FiltersList, {
  FilterNestedItem,
  FilterSingleItem,
} from '../filters-list/FiltersList';
import { Category } from '../../../models/domain/interfaces';
import { useRouter } from 'next/router';
import { Pages } from '../../../models/domain/enum';
import { getAvailableStringFromCategoryByLocale } from '../../../utils/categories';

import { CategoryTitle } from './MobileFiltersModal.style';

const MobileFiltersModal = ({
  translations,
  onClose,
  show,
  sections,
  rootSection,
  pageType,
}: {
  mainLinks?: any;
  megaMenuLinks?: any;
  translations: any;
  onClose: () => void;
  show: boolean;
  locale?: string;
  rootSection: string;
  sections: Record<string, Category[]>;
  pageType: Pages;
}) => {
  const { locale } = useRouter();
  const router = useRouter();
  const [openLocal] = useState(false);
  const { query, asPath } = router;

  const generateUrlInformation = useCallback(
    (
      voice: Category,
      subCategory?: Category,
      pageType?: Pages
    ): {
      url: string;
      queryCopy: any;
    } => {
      if (Pages.SECTOR !== pageType) {
        let url = `/${toKebabCaseWithAccentsCyrillicCJK(
          rootSection
        )}/${toKebabCaseWithAccentsCyrillicCJK(
          voice &&
            getAvailableStringFromCategoryByLocale(
              voice,
              locale,
              'packages/corporate-ui/src/components/mobile-filters/mobile-filters-modal/MobileFiltersModal.tsx'
            )
        )}`;

        if (!url) url = '/';

        const queryCopy = {
          ...query,
        };

        delete queryCopy?.slug;
        delete queryCopy?.q;

        if (subCategory) {
          queryCopy[
            translations?.queryParmas?.subcategory
          ] = `${subCategory.id}`;
        } else {
          delete queryCopy?.[translations?.queryParmas?.subcategory];
        }

        return {
          url,
          queryCopy,
        };
      } else {
        const url = asPath.split('?');

        const queryCopy = {
          ...query,
        };

        queryCopy[translations?.queryParmas?.subcategory] = `${
          subCategory?.id || voice.id
        }`;

        delete queryCopy.slug;
        delete queryCopy.q;
        return {
          url: url[0],
          queryCopy,
        };
      }
    },
    [asPath, locale, query, rootSection, translations?.queryParmas?.subcategory]
  );

  const generateUrl = useCallback(
    (voice: Category, subCategory?: Category, pageType?: Pages): string => {
      const { url, queryCopy } = generateUrlInformation(
        voice,
        subCategory,
        pageType
      );

      const query = serialize(queryCopy);

      return `${url}${query ? `?${query}` : ''}`;
    },
    [generateUrlInformation]
  );

  const prepareChildrenFilers = useCallback(
    (root: Category, father: Category, depth: number) => {
      const children = sections[root.id].filter(
        (subCategory) =>
          subCategory.depth === depth + 1 && subCategory.idFather === father.id
      );

      if (children.length === 0)
        return (
          <FilterSingleItem
            link={{
              text:
                father &&
                getAvailableStringFromCategoryByLocale(
                  father,
                  locale,
                  'packages/corporate-ui/src/components/mobile-filters/mobile-filters-modal/MobileFiltersModal.tsx'
                ),
              url: generateUrl(root, father, pageType),
            }}
            level={depth}
            onClick={onClose}
            open={openLocal}
          />
        );

      return (
        <FilterNestedItem
          link={{
            text:
              father &&
              getAvailableStringFromCategoryByLocale(
                father,
                locale,
                'packages/corporate-ui/src/components/mobile-filters/mobile-filters-modal/MobileFiltersModal.tsx'
              ),
            url: generateUrl(root, father, pageType),
          }}
          level={depth}
          onClick={onClose}
          open={openLocal}
        >
          {Children.toArray(
            children?.map((child) => {
              return prepareChildrenFilers(root, child, depth + 1);
            })
          )}
        </FilterNestedItem>
      );
    },
    [generateUrl, locale, onClose, openLocal, pageType, sections]
  );

  const preparedFilters = useMemo(() => {
    return (startDepth = 0) => {
      const topLevelVoices = Object.values(sections)
        .flat()
        .filter((category) => category.depth === startDepth);

      return Children.toArray(
        topLevelVoices?.map((firstLevelCategory) => {
          const firstLevelChildren = sections?.[firstLevelCategory?.id]?.filter(
            (category) => category.depth === startDepth + 1
          );

          if (firstLevelChildren?.length === 0)
            return (
              <FilterSingleItem
                level={startDepth}
                open={openLocal}
                link={{
                  text:
                    firstLevelCategory &&
                    getAvailableStringFromCategoryByLocale(
                      firstLevelCategory,
                      locale,
                      'packages/corporate-ui/src/components/mobile-filters/mobile-filters-modal/MobileFiltersModal.tsx'
                    ),
                  url: generateUrl(firstLevelCategory, undefined, pageType),
                }}
                onClick={onClose}
              />
            );

          return (
            <FilterNestedItem
              link={{
                text:
                  firstLevelCategory &&
                  getAvailableStringFromCategoryByLocale(
                    firstLevelCategory,
                    locale,
                    'packages/corporate-ui/src/components/mobile-filters/mobile-filters-modal/MobileFiltersModal.tsx'
                  ),
                url: generateUrl(firstLevelCategory, undefined, pageType),
              }}
              level={startDepth}
              onClick={onClose}
              open={openLocal}
            >
              {Children.toArray(
                firstLevelChildren?.map((secondLevelCategory) => {
                  return prepareChildrenFilers(
                    firstLevelCategory,
                    secondLevelCategory,
                    startDepth + 1
                  );
                })
              )}
            </FilterNestedItem>
          );
        })
      );
    };
  }, [
    generateUrl,
    locale,
    onClose,
    openLocal,
    pageType,
    prepareChildrenFilers,
    sections,
  ]);

  return (
    <ModalWrapper
      show={show}
      hideModal={onClose}
      showDefaultHeader={false}
      size={ModalSize.FULLSCREEN}
      styleType={ModalStyleType.mobileFilters}
    >
      <ModalWrapper.Header
        styleType={ModalStyleType.mobileFilters}
        typeHeader="content"
        onClose={onClose}
        showDivider
      >
        <ModalWrapper.Title
          styleType={ModalStyleType.mobileFilters}
          title={'Filters'}
        />
      </ModalWrapper.Header>
      <ModalWrapper.Body
        size={ModalSize.FULLSCREEN}
        styleType={ModalStyleType.mobileFilters}
      >
        <>
          <CategoryTitle>{rootSection}</CategoryTitle>
          <FiltersList>{preparedFilters()}</FiltersList>
        </>
      </ModalWrapper.Body>
    </ModalWrapper>
  );
};

export default MobileFiltersModal;
